<div class="flex flex-col gap-4">
  <form
    class="mt-4 flex items-start gap-4"
    [formGroup]="settingsForm"
    (ngSubmit)="submit()"
  >
    <div class="flex flex-auto flex-col items-start gap-4">
      <mat-slide-toggle formControlName="isEnabled">
        Enable HICAPS
      </mat-slide-toggle>

      <div class="flex flex-row items-start gap-1">
        <mat-checkbox formControlName="addCDBSAsPending">
          Add CDBS transactions as "pending" status
        </mat-checkbox>
        <mat-icon
          class="cdbs-tooltip"
          matTooltip="This will require CDBS claims to be reconciled from the pending transactions workflow."
          >info</mat-icon
        >
      </div>

      <button mat-flat-button type="submit" color="primary">Save</button>
    </div>

    <div *prIsManagement class="row flex items-start gap-4">
      <div class="!mb-0 flex flex-col items-start gap-4">
        <mat-slide-toggle formControlName="useV2Terminals">
          Use V2 Terminals (beta)
        </mat-slide-toggle>
        @if (practice$ | async; as practice) {
          <button
            type="button"
            mat-stroked-button
            [disabled]="isSeeding()"
            (click)="seedMerchants(practice)"
          >
            Detect merchants from V1
          </button>
        }
      </div>
      <div class="!mb-0 flex flex-col items-start gap-4">
        <mat-slide-toggle formControlName="testModeEnabled">
          Enable Test Mode
        </mat-slide-toggle>

        <button type="button" mat-stroked-button (click)="customRequest()">
          Send Custom Request
        </button>
      </div>
    </div>
  </form>

  @if (practice$ | async; as practice) {
    @if ((useV2Terminals$ | async) === false) {
      <mat-divider class="!my-2" />
      <div>
        <h3 class="!m-0 !font-bold">Terminals</h3>
        <p>
          Principle uses Principle Bridge to talk to HICAPS Terminals. A
          Principle Bridge Device must be set up on a computer in order to
          detect and use terminals in your practice.
        </p>
        <pr-practice-hicaps-connect-terminals [practice]="practice" />
      </div>
    } @else {
      <div class="flex flex-col gap-8">
        <pr-practice-hicaps-connect-v2-settings [practice]="practice" />
        <div *prIsManagement>
          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                V1 terminals (legacy, read-only)
              </mat-panel-title>
            </mat-expansion-panel-header>
            <pr-practice-hicaps-connect-terminals
              [practice]="practice"
              [readOnly]="true"
            />
          </mat-expansion-panel>
        </div>
      </div>
    }
  }
</div>
